import {CoreDI, Device, DisplayObjectUtils, inject, ModuleIsEnabledFilter, Installer} from '@gongxigames/framework/core';
import {SlotSettings} from '@gongxigames/framework/slot/configs/SlotSettings';
import {BottomPanelEvents} from '@gongxigames/framework/slot/modules/bottompanel/BottomPanelEvents';
import {GameConfig} from '@gongxigames/framework/slot/types';
import {InfoModule} from '@gongxigames/framework/slot/modules/info';
import {GameHistoryView} from '@gongxigames/framework/slot/modules/gameHistory/GameHistoryView';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';
import {HtmlSearch} from '@gongxigames/framework/core/fragments/HtmlSearch';

export class GameHistory extends InfoModule {
    public static readonly NAME: symbol = Symbol('GameHistory');
    public static readonly isEnabled: ModuleIsEnabledFilter = (components: Installer) => {
        return components.getComponent<SlotSettings>(CoreDI.Settings).get('gameHistoryListEnabled') || false;
    };

    @inject(CoreDI.Device)
    protected _device!: Device;

    @inject(CoreDI.DisplayObjectUtils)
    protected _displayObjectUtils!: DisplayObjectUtils;

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    private _gameHistoryView!: GameHistoryView;

    protected htmlSearch!: HtmlSearch;

    public init(): void {
        super.init();

        this._gameHistoryView = new GameHistoryView();
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.on('General.Popups.Add', this.close);
        strictUiEmitter.on('UI.menu.closed', this.close.bind(this));
        strictUiEmitter.on('UI.menu.historyButtonClicked', this.onPageClicked.bind(this));
        this.on(BottomPanelEvents.HISTORY_BUTTON_CLICKED, this.onPageClicked);
    }

    private onPageClicked(): void {
        const url = this.settings.get('historyUrl');

        if (this._gameHistoryView.isOpen || !url) {
            return;
        }

        this._gameHistoryView.onPageClicked(url, this.open.bind(this), this.onCLose.bind(this));
    }

    protected open(): void {
        super.open();

        this._currentContainer && this.eventManager.emit('General.GameHistory.Opened');
    }

    protected close(): void {
        if (this._gameHistoryView.isOpen) {
            this._gameHistoryView.close();

            super.close();

            this._currentContainer && this.eventManager.emit('General.GameHistory.Closed');
        }
    }

    protected onCLose(): void {
        if (this.isPlatformDesktop()) {
            this.soundPlayer.play('buttonclick');
        }

        this.close();
    }

    protected onResized(): void {
        if (this._gameHistoryView.isOpen) {
            requestAnimationFrame(() => {
                this.fitToGameDimensions();

                if (this.isPlatformMobile()) {
                    this.setContentSize();
                }
            });
        }
    }

    public setCurrentElements(): void {
        const {gameHistoryContainer, gameHistory} = this._gameHistoryView;

        this._currentContainer = gameHistoryContainer;
        this._currentPage = gameHistory;
    }
}
